import _ from "lodash";

export const parseUserDetailsPayload = (payload) => {
    payload.reportScores = sortArray(payload.reportScores, 'reportPullDate');
    payload.subscriptions = sortArray(payload.subscriptions, 'createTs');
    payload.activePlaidRisk = {};
    payload.pastActivePlaidRisks = [];
    payload.failedPlaidRisks = [];

    if (payload.plaidAdminResponse) {
        payload.activePlaidRisk = getPlaidResponse(payload.plaidAdminResponse.activePlaidConnectionsResponse);
        payload.pastActivePlaidRisks = _.map(payload?.plaidAdminResponse?.pastActivePlaidConnectionsResponse, (data) => getPlaidResponse(data));
        payload.failedPlaidRisks = _.map(payload?.plaidAdminResponse?.failedPlaidConnectionsResponse, (data) => getPlaidResponse(data));
        payload.deletedPlaidConnectionsResponse = _.map(payload?.plaidAdminResponse?.deletedPlaidConnectionsResponse, (data) => getPlaidResponse(data));
    }

    payload.saveAndBuildCredit = payload?.sbAdminResponse?.savingBuilders || [];
    payload.saveAndBuildCredit = sortArray(payload.saveAndBuildCredit, 'loanStartInstant');
    payload.subscriptions = getSubscriptionsData(payload.subscriptions, payload.domainSubscriptions);
    payload.merchantList = sortArray(payload.merchantList, 'displayName', 'asc');

    return payload;
}

export function handleCreditCardPayload(payload, domains) {
    const creditCardEntries = payload?.creditCardEntries;
    payload.creditCards = creditCardEntries || [];
    return _.map(payload.creditCards, (card, index) => {
        const domain = _.find(domains || [], (_domainSub) => card.id === _domainSub.card.id) || {};

        const creditCardTransactions = payload?.creditCardResponses[index].transactionDetails;
        const creditCardPayments = payload?.creditCardResponses[index].creditCardPayments;
        const creditCardDeclinedTransactions = payload?.creditCardResponses[index].creditCardDeclinedTransactions;
        const maxAccountBalance = payload?.creditCardResponses[index].maxAccountBalance;
        const accountDetails = payload?.creditCardResponses[index].accountDetails;
        const creditCardMetaData = payload?.creditCardResponses[index].creditCardMetaData || {};
        const dueDaySetByUser = payload?.creditCardResponses[index].dueDaySetByUser
        const spendPowerUsed = payload?.creditCardResponses[index].spendPowerUsed;
        const spendPowerAvailable = payload?.creditCardResponses[index].spendPowerAvailable;
        const paymentDueDay = payload?.creditCardResponses[index].paymentDueDay;
        const accountStatus = payload?.creditCardResponses[index].accountStatus;
        const spendPowerSummary = payload?.creditCardResponses[index].spendPower || {};
        const boostsPending = payload?.creditCardResponses[index].boostsPending || {};
        const activeSubscriptions = payload?.creditCardResponses[index].activeSubscriptions || {};
        const spendModeSummary = payload?.creditCardResponses[index].spendModeSummary || {};
        const creditLimitChanges = payload?.creditCardResponses[index].creditLimitChanges || [];
        const spendLimitChanges = payload?.creditCardResponses[index].spendLimitChanges || [];
        const baseCreditLimit = payload?.creditCardResponses[index].baseCreditLimit || {};

        card.creditCardTransactions = sortArray(creditCardTransactions, 'transactionTime');
        card.creditCardPayments = sortArray(creditCardPayments, 'createTs');
        card.declinedTransactions = sortArray(creditCardDeclinedTransactions, 'createTs');
        card.accountDetails = accountDetails;
        card.creditCardMetaData = creditCardMetaData;
        card.dueDaySetByUser = dueDaySetByUser;
        card.spendPowerUsed = spendPowerUsed;
        card.spendPowerAvailable = spendPowerAvailable;
        card.paymentDueDay = paymentDueDay;
        card.accountStatus = accountStatus;
        card.spendPowerSummary = spendPowerSummary;
        card.boostsPending = boostsPending;
        card.activeSubscriptions = activeSubscriptions;
        card.spendModeSummary = spendModeSummary;
        card.creditLimitChanges = creditLimitChanges;
        card.spendLimitChanges = spendLimitChanges;
        card.baseCreditLimit = baseCreditLimit;
        card.domain = domain;

        card.maxAccountBalance = maxAccountBalance;
        if (card.creditCardPayments && card.creditCardPayments.length > 0) {
            card.outstandingPaymentStatus = card.creditCardPayments[0].paymentStatus;
        }
        card.spendPowerStatus = [];
        return card;
    })
}

function getSubscriptionsData(subscriptions = [], domainSubscriptions = []) {
    return _.map(subscriptions, (_subs) => {
        let subscriptionObj = _.find(domainSubscriptions, (_domainSub) => _subs.id === _domainSub.id) || {};
        let newSubObject = {};
        if (subscriptionObj) {
            newSubObject = { ..._subs, ...subscriptionObj };
        } else {
            newSubObject = { ..._subs };
        }

        newSubObject.status = _subs?.status || subscriptionObj?.status;
        newSubObject.stripeSubscriptionId = _subs?.stripeSubscriptionEntry?.stripeSubscriptionId || subscriptionObj.stripeSubscriptionId;

        return newSubObject;
    })
}

export const sortArray = (data = [], key, order = 'desc') => {
    return _.orderBy(data, [item => item[key]], [order]);

}

function getPlaidResponse(data) {
    if (data === null || data === undefined) {
        data = {};
    }
    return {
        ...data.plaidConnection,
        disconnectReason: data.disconnectReason,
        riskLevel: data.riskLevel,
        disconnectDate: data.disconnectDate,
        cachedPlaidBalance: data?.cachedPlaidBalance
    };
}

export function getAutoPayStatus(autoPayStatus, productType) {
    const status = {
        isDisabled: autoPayStatus?.isDisabled == true,
        autoPayDay: autoPayStatus?.default?.autoPayDay,
    }

    if (productType !== "all") {
        const historyItems = autoPayStatus?.products?.filter((history) => history.productType === productType);
        
        if (historyItems?.length > 0) {
            // get max item by created
            const maxItem = _.maxBy(historyItems, 'created');
            console.log('maxItem', maxItem, productType);
            status.isDisabled = maxItem?.enabled == false;
            status.autoPayDay = maxItem?.autoPayDay;
        }
    }
    
    return status;
    
}
